import classNames from 'classnames';
import React from 'react';
import { Typography } from "../typography/Typography.js";
import styles from "./BaseStatusCode.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BaseStatusCode = ({
  className,
  illustration,
  title,
  description,
  component
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles.statusCode, className),
    "aria-live": "assertive",
    children: [illustration, /*#__PURE__*/_jsxs("div", {
      className: styles.textContent,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h2",
        margin: false,
        children: title
      }), /*#__PURE__*/_jsx(Typography, {
        margin: false,
        children: description ?? 'Vielleicht finden Sie auf der Startseite was Sie suchen!'
      })]
    }), component]
  });
};